import { render, staticRenderFns } from "./ParamOcorrenciaOrigemForm.vue?vue&type=template&id=dcb09bfc"
import script from "./ParamOcorrenciaOrigemForm.vue?vue&type=script&lang=js"
export * from "./ParamOcorrenciaOrigemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports